import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import { useDispatch, useSelector } from "react-redux";
import PersonIcon from "@mui/icons-material/Person";
import ItemInputCard from "~business/Cards/ItemInputCard";
import ItemPhoneCard from "~business/Cards/ItemPhoneCard";
import { hasOnlyLandline } from "~styled/phone/parsePhone";
import type { FieldChangeEvent } from "~business/Cards/types";

import {
  setMail,
  setTelefono,
  setNumeroDocumentoAsegurado,
  setNombreAsegurado,
  setSubmitting,
} from "../actions";
import { CampoSiniestro, PolizaVinculada } from "../../../types";

interface SliceDatosAsegurado {
  numeroDocumentoAsegurado: CampoSiniestro;
  nombreAsegurado: CampoSiniestro;
  mail: CampoSiniestro;
  telefono: CampoSiniestro;
  poliza: PolizaVinculada | null;
}

const useReduxSelector = () =>
  useSelector<any, SliceDatosAsegurado>((state) => ({
    numeroDocumentoAsegurado:
      state.cargaSiniestroReducer.numeroDocumentoAseguradoSelected,
    nombreAsegurado: state.cargaSiniestroReducer.nombreAseguradoSelected,
    mail: state.cargaSiniestroReducer.mailSelected,
    telefono: state.cargaSiniestroReducer.telefonoSelected,
    poliza: state.cargaSiniestroReducer.polizaVinculada,
  }));

const title = "Datos del Asegurado";

interface DatosAseguradoCardProps {
  isLoading?: boolean;
}

const DatosAseguradoCard = ({ isLoading }: DatosAseguradoCardProps) => {
  const dispatch = useDispatch();

  const { numeroDocumentoAsegurado, nombreAsegurado, mail, telefono, poliza } =
    useReduxSelector();
  const soloFijo = hasOnlyLandline(poliza?.asegurado);

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleChangeNumeroDocumento = (
    numeroDocumento: FieldChangeEvent<string | null>
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNumeroDocumentoAsegurado(numeroDocumento));
    }, 200);
  };

  const handleChangeNombre = (nombre: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNombreAsegurado(nombre));
    }, 200);
  };

  const handleChangeMail = (mail: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setMail(mail));
    }, 200);
  };

  const handleChangeTelefono = (telefono: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setTelefono(telefono));
    }, 200);
  };

  const handleBlur = () => {
    dispatch(setSubmitting(false));
  };

  return (
    <>
      <DetalleCard title={title} IconHeader={PersonIcon}>
        {!poliza && (
          <>
            <ItemInputCard
              id={"dni"}
              isLoading={isLoading}
              label={"DNI"}
              value={""}
              onChange={handleChangeNumeroDocumento}
              onBlur={handleBlur}
              focus={numeroDocumentoAsegurado.focus}
              required
            />
            <ItemInputCard
              id={"nombreAsegurado"}
              isLoading={isLoading}
              label={"Nombre Completo"}
              value={""}
              onChange={handleChangeNombre}
              onBlur={handleBlur}
              focus={nombreAsegurado.focus}
              required
            />
            <ItemInputCard
              id={"mail"}
              isLoading={isLoading}
              label={"Correo Electrónico"}
              value={mail.value}
              onChange={handleChangeMail}
              focus={mail.focus}
              required
            />
            <ItemPhoneCard
              onlyMobile
              id={"telefono"}
              isLoading={isLoading}
              label={"Teléfono"}
              value={telefono.value}
              onChange={handleChangeTelefono}
              focus={telefono.focus}
              required
            />
          </>
        )}
        {poliza && (
          <>
            <ItemInputCard
              id={"dni"}
              isLoading={isLoading}
              label={"DNI"}
              value={numeroDocumentoAsegurado.value}
              readOnly
            />
            <ItemInputCard
              id={"nombreAsegurado"}
              isLoading={isLoading}
              label={"Nombre Completo"}
              value={nombreAsegurado.value}
              readOnly
            />
            <ItemInputCard
              id={"mail"}
              isLoading={isLoading}
              label={"Correo Electrónico"}
              value={mail.value}
              onChange={handleChangeMail}
              focus={mail.focus}
              required
            />
            <ItemPhoneCard
              onlyMobile={!soloFijo}
              isMobile={!soloFijo}
              id={"telefono"}
              isLoading={isLoading}
              label={"Teléfono"}
              value={telefono.value}
              onChange={handleChangeTelefono}
              focus={telefono.focus}
              required
            />
          </>
        )}
      </DetalleCard>
    </>
  );
};

export default DatosAseguradoCard;
